import {Action, Actions, Selector, State, StateContext, StateToken} from '@ngxs/store';
import {takeUntil, tap} from 'rxjs/operators';
import {FetchTrials} from './trials.actions';
import {FetchOrder, FetchOnboardingGoals} from './onboarding.actions';
import {OrdersModelResponse} from '../api/responses/orders-response';
import {OrderModelResponse} from '../api/responses/order-response';
import {Logout} from './auth.actions';
import {OnboardingRepositoryService} from '../api/repositories/onboarding-repository.service';
import {OnboardingGoalModelResponse} from '../api/responses/onboarding-response';


interface OnboardingStateModel {
    order: OrderModelResponse|null;
    goals: OnboardingGoalModelResponse[]
}

@State<OnboardingStateModel>({
    name: 'Goals',
    defaults: {
        order: null,
        goals: [],
    }
})
export class OnboardingState {
    constructor(
        private actions: Actions,
        private onboardingRepository: OnboardingRepositoryService
    ) {
    }

    @Selector()
    public static order(state: OnboardingStateModel): OrderModelResponse|null {
        return state.order;
    }

    @Selector()
    public static orders(state: OnboardingStateModel): OnboardingGoalModelResponse[] {
        return state.goals;
    }

    @Action(FetchOnboardingGoals)
    public fetchOnboardingGoals(ctx: StateContext<OnboardingStateModel>, action: FetchOnboardingGoals) {
        let request = this.onboardingRepository.listByAccountId(action.accountId)
            .pipe(
                tap(response => {
                    ctx.patchState({
                        goals: response.data.items
                    });
                })
            );

        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }

        return request;
    }


    @Action(FetchOrder)
    public fetchOrder(ctx: StateContext<OnboardingStateModel>, action: FetchOrder) {
        let request = this.onboardingRepository.findByAccountIdAndOrderNo(action.accountId, action.orderNo)
            .pipe(tap(response => ctx.patchState({
                order: response.data
            })));

        if (action.cancellationToken) {
            request = request.pipe(takeUntil(action.cancellationToken));
        }

        return request;
    }

    @Action(Logout)
    public logout(ctx: StateContext<OnboardingStateModel>, action: Logout) {
        ctx.patchState({
            order: null,
            goals: null,
        });
    }
}
